/**
 * components/hazard/hazardModes.js — 5 хувилбарын тохиргоо.
 *
 * Section түлхүүрүүд:
 *   "photo" | "location" | "hazardType" | "description" | "severity" |
 *   "whoExposed" | "remedy" | "date" | "inspectionLevel" | "inspectionType"
 *   | "worker" | "infoClass" | "violationClass" | "saveBar"
 *
 * Энэхүү config-ыг HazardFormComposer-д өгч хэсэг бүрийн харагдалт болон
 * дарааллыг хянана.
 */

export const MODE_CONFIGS = {
  // 1) Энгийн ажлын даалгаврын ажилтан — товч маягт
  naryad: {
    title: "Аюул мэдээлэх",
    sections: [
      "photo",
      "location",
      // ⚠ `hazardType` нь ЭНЭ горимд ДУТУУ байсан — `oea` ба `violation`
      //   горимд аль хэдийн байсан атал энгийн ажилтны «Аюул мэдээлэх»
      //   маягтад (ажлын даалгаваргүй хүн, /me → «Аюул мэдээлэх») огт
      //   гардаггүй байв. Улмаас бүртгэл бүр ангилалгүй ирж, дүн
      //   шинжилгээнд «төрөл тодорхойгүй» болж хуримтлагддаг байлаа.
      "hazardType",
      // ⚠ МЭДЭЭЛЛИЙН АНГИЛАЛ — «юуны тухай мэдээлэл вэ» (ажлын байр, ХХХ,
      //   тээвэр…). Лавлахаас (`xab.violation_reference`, kind=info_class)
      //   сонгогдоно. Энгийн ажилтны бүртгэлд энэ ангилал байхгүй үед
      //   мэдээллүүд нь зөвхөн чөлөөт тайлбартай ирж, сарын тайлангийн
      //   ангиллын задаргаанд орж чаддаггүй байв.
      //   ⚠ ЗӨВХӨН ангилал: эрсдэлийн түвшин / эрсдэлтэй эсэх нь ХАБ-ын
      //     мэргэжлийн дүгнэлт тул энэ маягтад ГАРАХГҮЙ (`infoClassOnly`).
      "infoClass",
      "description",
      "whoExposed",
      "saveBar",
    ],
    primaryLabel: "Илгээх",
    showDraft: true,
    hideDeptSelectors: true,
    // Зөвхөн «Мэдээллийн ангилал» — түвшин/эрсдэлтэй эсэхгүйгээр
    infoClassOnly: true,
  },

  // 2) ӨЭА-н наряд заавар авч ажилд гарсан хүн
  oea: {
    title: "Аюул мэдээлэх",
    sections: [
      "photo",
      "location",
      "hazardType",
      "description",
      "severity",
      "whoExposed",
      "saveBar",
    ],
    primaryLabel: "Илгээх",
    showDraft: true,
    hideDeptSelectors: true,
  },

  // 3) БН ХАБ ажилтан — зөрчил бүртгэх
  violation: {
    title: "Зөрчил бүртгэх",
    sections: [
      // ⚠ ХАМГИЙН ЭХЭНД. Зөрчил нь ХҮНД холбогддог тул хэнд
      //   бичиж байгаагаа ЭХЛЭЭД баталгаажуулна — буруу хүнд
      //   бичигдсэн зөрчил нь хариуцлага тооцоход шууд алдаа.
      "worker",
      "photo",
      "location",
      // ⚠ ҮЗЛЭГИЙН ТӨРӨЛ энэ горимд ДУТУУ байв — зөрчлийн бусад бүх
      //   горимд (bn_violation, hab_dept_violation, all_violation)
      //   байдаг атал ЯГ «Зөрчил бүртгэх» гэж нэрлэгдсэн горимд
      //   алга байсан. Улмаас энэ маягтаар бүртгэсэн зөрчил
      //   `inspection_type` талбаргүй ирж, дүн шинжилгээнд «төрөл
      //   тодорхойгүй» болж хуримтлагдана.
      "inspectionType",
      // Шатны хэсэг нь өөрөө ЗӨВХӨН «Шат шатны үзлэг» төрөлд гарна
      // (`inspectionFlowFor(...).visible`) тул бусад төрөлд саад болохгүй.
      // Үүнгүйгээр шат сонгох боломжгүй, дутуу бүртгэл үүснэ.
      "inspectionLevel",
      "hazardType",
      // ⚠ ТАЙЛБАРААС ӨМНӨ. Хуучин зөрчлийн бүртгэл дээр «Мэдээллийн
      //   төрөл · Эрсдэлийн түвшин · Эрсдэлтэй эсэх» гурав ҮРГЭЛЖ
      //   дэлгэрэнгүйгээс өмнө асуугддаг байсан — бүртгэгч эхлээд
      //   «юуны тухай, хэр аюултай вэ» гэдгээ шийдээд дараа нь
      //   бичдэг. Доор нь тавибал ангилал нь мартагдаж хоосон үлддэг.
      "infoClass",
      "description",
      "severity",
      "whoExposed",
      // ⚠ Хяналт шалгалт нь ШАЛГАХ ХУУДСААР явдаг тул үзүүлэлт бүр
      //   өөрийн мөртэй. Зөрчил нь хуудасгүй — «хэн юу хийх вэ,
      //   хэзээ хүртэл» гэдгийг ЭНД бичихээс өөр газар алга.
      // Зөрчлийн төрөл · зөрчсөн заалт · шийтгэл — лавлахаас.
      // ⚠ Гараар бичвэл нэг зүйл олон хэлбэрээр үүсч тоолох
      //   боломжгүй болно; буруу эшилсэн заалт нь албан
      //   шаардлагын үндэслэлийг хүчингүй болгож ч мэднэ.
      "violationClass",
      "remedy",
      "date",
      "saveBar",
    ],
    // «Огноо» гэвэл ямар огноо болох нь ойлгомжгүй — зөрчил гарсан
    // огноо ч байж мэднэ. Бүртгэлийн огноо гэдгийг ТОДОРХОЙ хэлнэ.
    dateTitle: "Бүртгэгдсэн огноо",
    primaryLabel: "Зөрчил бүртгэх",
    showDraft: true,
    showArchive: false,
  },

  // 4) ХАБ хэлтсийн мэргэжилтэн — 3-4 шатны үзлэг
  //    ⚠ ХЭРЭГЛЭГДДЭГГҮЙ (үхмэл тохиргоо) — аль ч хуудас энэ горимыг дуудахгүй.
  //    Шатны шинэ хуваарь (БН 1-3 / ХАБ хэлтэс 4) энд тусгагдаагүй.
  inspection_34: {
    title: "3-4 шатны үзлэг",
    sections: [
      "photo",
      "location",
      "inspectionType",
      "inspectionLevel",
      "hazardType",
      "description",
      "severity",
      "whoExposed",
      // Зөрчилд ЭЗЭН ба ХУГАЦАА байх ёстой — доорх тайлбарыг үз
      "remedy",
      "date",
      "saveBar",
    ],
    primaryLabel: "Үзлэг хадгалах",
    showArchive: true,
    showDraft: true,
    defaultInspectionLevel: 3,
  },

  // 5) ХАБ ерөнхий шалгалт (бүх төрлөөр шалгах боломжтой)
  inspection_full: {
    title: "ХАБ шалгалт",
    sections: [
      "photo",
      "location",
      "inspectionType",
      "inspectionLevel",
      "hazardType",
      "description",
      "severity",
      "whoExposed",
      "remedy",
      "date",
      "saveBar",
    ],
    primaryLabel: "Шалгалт хадгалах",
    showArchive: true,
    showDraft: true,
  },

  // 6) ӨЭА ажилтан 15 асуумжийн дунд асуудал илрүүлсэн — Ажил зогсоох
  //    Header: "Ажил зогсоох", primary button: "Ажил зогсоох"
  stop_work: {
    title: "Ажил зогсоох",
    sections: [
      "photo",
      "location",
      "hazardType",
      "description",
      "severity",
      "whoExposed",
      "saveBar",
    ],
    primaryLabel: "Ажил зогсоох",
    showDraft: false,
    showArchive: false,
    hideDeptSelectors: true,
  },

  // 6.5) БН ХАБ ажилтан (usergroup=179) — ҮЕРОНГИЙН ЗӨРЧЛИЙН МЭДЭЭЛЭЛ
  //    Header: "Хяналт шалгалт"
  //    Зөвхөн 1-3 дугаар шатны үзлэг идэвхтэй (4-р шат disabled).
  //    Description label "Илэрсэн зөрчлийн дэлгэрэнгүй" болсон.
  bn_violation: {
    title: "Хяналт шалгалт",
    sections: [
      // ⚠ ХАМГИЙН ЭХЭНД. Зөрчил нь ХҮНД холбогддог тул хэнд
      //   бичиж байгаагаа ЭХЛЭЭД баталгаажуулна — буруу хүнд
      //   бичигдсэн зөрчил нь хариуцлага тооцоход шууд алдаа.
      "worker",
      "location",
      "inspectionType",
      "inspectionLevel",
      "photo",
      // ⚠ ТАЙЛБАРААС ӨМНӨ. Хуучин зөрчлийн бүртгэл дээр «Мэдээллийн
      //   төрөл · Эрсдэлийн түвшин · Эрсдэлтэй эсэх» гурав ҮРГЭЛЖ
      //   дэлгэрэнгүйгээс өмнө асуугддаг байсан — бүртгэгч эхлээд
      //   «юуны тухай, хэр аюултай вэ» гэдгээ шийдээд дараа нь
      //   бичдэг. Доор нь тавибал ангилал нь мартагдаж хоосон үлддэг.
      "infoClass",
      "description",
      // ⚠ Зөрчилд ЭЗЭН ба ХУГАЦАА байх ёстой. Хяналт шалгалт нь
      //   ШАЛГАХ ХУУДСААР явдаг тул үзүүлэлт бүр өөрийн мөртэй;
      //   зөрчил нь хуудасгүй тул «хэн юу хийх вэ, хэзээ хүртэл»
      //   гэдгийг ЭНД бичихээс өөр газар алга. Хуучин зөрчлийн
      //   бүртгэлийн `description_comment` + `tn` + `end_date`.
      // Зөрчлийн төрөл · зөрчсөн заалт · шийтгэл — лавлахаас.
      // ⚠ Гараар бичвэл нэг зүйл олон хэлбэрээр үүсч тоолох
      //   боломжгүй болно; буруу эшилсэн заалт нь албан
      //   шаардлагын үндэслэлийг хүчингүй болгож ч мэднэ.
      "violationClass",
      "remedy",
      // ⚠ БҮРТГЭГДСЭН ОГНОО. Зөрчлийг олсон өдөртөө бүртгэж чаддаггүй
      //   (талбар дээр, ээлж дуусахад) тул огноо нь заавал засагддаг
      //   байх ёстой. Үүнгүй бол бүх зөрчил бүртгэсэн өдрийнхөө
      //   огноогоор тоологдож, статистик хойшоо гулсана.
      "date",
      "saveBar",
    ],
    // «Огноо» гэвэл ямар огноо болох нь ойлгомжгүй — зөрчил гарсан
    // огноо ч байж мэднэ. Бүртгэлийн огноо гэдгийг ТОДОРХОЙ хэлнэ.
    dateTitle: "Бүртгэгдсэн огноо",
    primaryLabel: "Зөрчил бүртгэх",
    showDraft: true,
    showArchive: false,
    defaultInspectionLevel: 1,
    inspectionLevels: [1, 2, 3, 4],
    // БН-ийн ХАБ ажилтан, удирдлага зэрэг нь 1-3 дугаар шатны шалгалт хийнэ.
    // 4-р шат нь ХАБ хэлтэс/эрх бүхий хэлтсийн мэргэжилтний түвшин.
    inspectionLevelsDisabled: [4],
    descriptionTitle: "Илэрсэн зөрчлийн дэлгэрэнгүй",
  },

  // 6.6) ХАБ хэлтсийн мэргэжилтэн (ба лавлахад эрх нь тавигдсан бусад
  //    хэлтэс) — ЗӨРЧЛИЙН МЭДЭЭЛЭЛ, ЗӨВХӨН 4 дүгээр шатны үзлэг.
  //    Header: "Хяналт шалгалт"
  //    bn_violation-той ижил бүтэц, гэхдээ зөвхөн 4-р шат идэвхтэй.
  hab_dept_violation: {
    title: "Хяналт шалгалт",
    sections: [
      // ⚠ ХАМГИЙН ЭХЭНД. Зөрчил нь ХҮНД холбогддог тул хэнд
      //   бичиж байгаагаа ЭХЛЭЭД баталгаажуулна — буруу хүнд
      //   бичигдсэн зөрчил нь хариуцлага тооцоход шууд алдаа.
      "worker",
      "location",
      "inspectionType",
      "inspectionLevel",
      "photo",
      // ⚠ ТАЙЛБАРААС ӨМНӨ. Хуучин зөрчлийн бүртгэл дээр «Мэдээллийн
      //   төрөл · Эрсдэлийн түвшин · Эрсдэлтэй эсэх» гурав ҮРГЭЛЖ
      //   дэлгэрэнгүйгээс өмнө асуугддаг байсан — бүртгэгч эхлээд
      //   «юуны тухай, хэр аюултай вэ» гэдгээ шийдээд дараа нь
      //   бичдэг. Доор нь тавибал ангилал нь мартагдаж хоосон үлддэг.
      "infoClass",
      "description",
      // ⚠ Зөрчилд ЭЗЭН ба ХУГАЦАА байх ёстой. Хяналт шалгалт нь
      //   ШАЛГАХ ХУУДСААР явдаг тул үзүүлэлт бүр өөрийн мөртэй;
      //   зөрчил нь хуудасгүй тул «хэн юу хийх вэ, хэзээ хүртэл»
      //   гэдгийг ЭНД бичихээс өөр газар алга. Хуучин зөрчлийн
      //   бүртгэлийн `description_comment` + `tn` + `end_date`.
      // Зөрчлийн төрөл · зөрчсөн заалт · шийтгэл — лавлахаас.
      // ⚠ Гараар бичвэл нэг зүйл олон хэлбэрээр үүсч тоолох
      //   боломжгүй болно; буруу эшилсэн заалт нь албан
      //   шаардлагын үндэслэлийг хүчингүй болгож ч мэднэ.
      "violationClass",
      "remedy",
      // ⚠ БҮРТГЭГДСЭН ОГНОО. Зөрчлийг олсон өдөртөө бүртгэж чаддаггүй
      //   (талбар дээр, ээлж дуусахад) тул огноо нь заавал засагддаг
      //   байх ёстой. Үүнгүй бол бүх зөрчил бүртгэсэн өдрийнхөө
      //   огноогоор тоологдож, статистик хойшоо гулсана.
      "date",
      "saveBar",
    ],
    // «Огноо» гэвэл ямар огноо болох нь ойлгомжгүй — зөрчил гарсан
    // огноо ч байж мэднэ. Бүртгэлийн огноо гэдгийг ТОДОРХОЙ хэлнэ.
    dateTitle: "Бүртгэгдсэн огноо",
    primaryLabel: "Зөрчил бүртгэх",
    showDraft: true,
    showArchive: false,
    defaultInspectionLevel: 4,
    inspectionLevels: [1, 2, 3, 4],
    inspectionLevelsDisabled: [1, 2, 3],
    descriptionTitle: "Илэрсэн зөрчлийн дэлгэрэнгүй",
  },

  // 6.7) БҮРЭН ЭРХ (sso_owner · ХАБ хэлтсийн үйлдвэрийн түвшний бүлэг) —
  //    ЗӨРЧЛИЙН МЭДЭЭЛЭЛ, БҮХ ШАТ нээлттэй.
  //    ⚠ Өмнө нь эдгээр хэрэглэгч `hab_dept_violation`-оор бичдэг байсан тул
  //    доод шатууд ХААЛТТАЙ болдог байв. Бүрэн эрхтэй хүн аль ч шатны зөрчлийг
  //    бүртгэх ёстой (жишээ нь БН-ийн 1-р шатны зөрчлийг залруулж бүртгэх).
  all_violation: {
    title: "Хяналт шалгалт",
    sections: [
      // ⚠ ХАМГИЙН ЭХЭНД. Зөрчил нь ХҮНД холбогддог тул хэнд
      //   бичиж байгаагаа ЭХЛЭЭД баталгаажуулна — буруу хүнд
      //   бичигдсэн зөрчил нь хариуцлага тооцоход шууд алдаа.
      "worker",
      "location",
      "inspectionType",
      "inspectionLevel",
      "photo",
      // ⚠ ТАЙЛБАРААС ӨМНӨ. Хуучин зөрчлийн бүртгэл дээр «Мэдээллийн
      //   төрөл · Эрсдэлийн түвшин · Эрсдэлтэй эсэх» гурав ҮРГЭЛЖ
      //   дэлгэрэнгүйгээс өмнө асуугддаг байсан — бүртгэгч эхлээд
      //   «юуны тухай, хэр аюултай вэ» гэдгээ шийдээд дараа нь
      //   бичдэг. Доор нь тавибал ангилал нь мартагдаж хоосон үлддэг.
      "infoClass",
      "description",
      // ⚠ Зөрчилд ЭЗЭН ба ХУГАЦАА байх ёстой. Хяналт шалгалт нь
      //   ШАЛГАХ ХУУДСААР явдаг тул үзүүлэлт бүр өөрийн мөртэй;
      //   зөрчил нь хуудасгүй тул «хэн юу хийх вэ, хэзээ хүртэл»
      //   гэдгийг ЭНД бичихээс өөр газар алга. Хуучин зөрчлийн
      //   бүртгэлийн `description_comment` + `tn` + `end_date`.
      // Зөрчлийн төрөл · зөрчсөн заалт · шийтгэл — лавлахаас.
      // ⚠ Гараар бичвэл нэг зүйл олон хэлбэрээр үүсч тоолох
      //   боломжгүй болно; буруу эшилсэн заалт нь албан
      //   шаардлагын үндэслэлийг хүчингүй болгож ч мэднэ.
      "violationClass",
      "remedy",
      // ⚠ БҮРТГЭГДСЭН ОГНОО. Зөрчлийг олсон өдөртөө бүртгэж чаддаггүй
      //   (талбар дээр, ээлж дуусахад) тул огноо нь заавал засагддаг
      //   байх ёстой. Үүнгүй бол бүх зөрчил бүртгэсэн өдрийнхөө
      //   огноогоор тоологдож, статистик хойшоо гулсана.
      "date",
      "saveBar",
    ],
    // «Огноо» гэвэл ямар огноо болох нь ойлгомжгүй — зөрчил гарсан
    // огноо ч байж мэднэ. Бүртгэлийн огноо гэдгийг ТОДОРХОЙ хэлнэ.
    dateTitle: "Бүртгэгдсэн огноо",
    primaryLabel: "Зөрчил бүртгэх",
    showDraft: true,
    showArchive: false,
    defaultInspectionLevel: 1,
    inspectionLevels: [1, 2, 3, 4],
    inspectionLevelsDisabled: [], // бүх шат идэвхтэй
    descriptionTitle: "Илэрсэн зөрчлийн дэлгэрэнгүй",
  },

  // 7) Ажлын даалгаврын ажилтан 5А асуумжийн дунд асуудал илрүүлсэн —
  //    Ажлын байрны үнэлгээ хэлбэрээр аюул мэдээлэх.
  //    Header: "Аюулын мэдээлэл ажлын байрны үнэлгээ"
  //    hazardType болон date байхгүй (товч бүртгэлд хангалттай).
  workplace_assessment: {
    title: "Аюулын мэдээлэл ажлын байрны үнэлгээ",
    sections: [
      "photo",
      "location",
      "description",
      "severity",
      "whoExposed",
      "saveBar",
    ],
    primaryLabel: "Илгээх",
    showDraft: false,
    showArchive: false,
    hideDeptSelectors: true,
  },
};

export const MODE_KEYS = Object.keys(MODE_CONFIGS);

/** Mode-ыг авч тохиргоог буцаах. Default → naryad. */
/**
 * Горимын тохиргоо авах.
 *
 * ⚠ Танихгүй горимыг ЧИМЭЭГҮЙ `naryad` (энгийн аюул мэдээлэх маягт) руу
 * унагадаг байсан нь алдааг нуудаг байв: зөрчлийн маягт хүсээд огт өөр
 * маягт гарч ирэхэд шалтгаан нь мэдэгдэхгүй, бүртгэл буруу төрлөөр
 * хадгалагдах эрсдэлтэй. Тиймээс console-д анхааруулна (production-д
 * зан төлөв өөрчлөгдөхгүй, зөвхөн мэдээлэл).
 */
export const getModeConfig = (mode) => {
  const cfg = MODE_CONFIGS[mode];
  if (!cfg) {
    // eslint-disable-next-line no-console
    console.warn(
      `[hazardModes] танихгүй горим "${mode}" — "naryad" руу унав. ` +
        `Боломжит горим: ${Object.keys(MODE_CONFIGS).join(", ")}`,
    );
  }
  return cfg || MODE_CONFIGS.naryad;
};
